import io from 'socket.io-client'
import { envConfig } from '@/env-config'

const wsIO = io(envConfig.ccsWSurl, {
  autoConnect: true,
  reconnection: true,
  reconnectionDelay: 2 * 1000,
  reconnectionDelayMax: 60 * 1000,
  timeout: 5 * 1000,
  path: '/agent-events',
  // query: {
  //   userInfo,
  // },
})

export default wsIO
